import { useMutation, useQuery } from '@tanstack/react-query';
import { createReviewRequestApi, getQuickReviewUsersApi, getReviewRequestCards, getReviewRequestListing } from './reviewRequest.api.js';

// ── Query keys ─────────────────────────────────────────────────────────────
export const reviewRequestKeys = {
    all: ['reviewRequests'],
    cards: () => [...reviewRequestKeys.all, 'dashboard-cards'],
    listing: (params) => [...reviewRequestKeys.all, 'listing', params],
    quickReviewUsers: (params) => [...reviewRequestKeys.all, 'quickReviewUsers', params],
};

// ── Dashboard card counts ──────────────────────────────────────────────────
export const useReviewRequestCards = (options = {}) => {
    return useQuery({
        queryKey: reviewRequestKeys.cards(),
        // IMPORTANT: pass the function reference; don't invoke it here
        queryFn: getReviewRequestCards,

        staleTime: 0,
        gcTime: 5 * 60 * 1000,
        refetchOnMount: 'always',
        refetchOnWindowFocus: false,

        ...options,
    });
};

// ── Review request listing ─────────────────────────────────────────────────
export const useReviewRequestListing = (params, options = {}) => {
    return useQuery({
        queryKey: reviewRequestKeys.listing(params),
        queryFn: () => getReviewRequestListing(params),
        staleTime: 0,
        gcTime: 5 * 60 * 1000,
        refetchOnMount: 'always',
        refetchOnWindowFocus: false,
        ...options,
    });
};

// ── Use Quick Review Users ────────────────────────────────────────────────
export const useQuickReviewUsers = (params, options = {}) => {
    return useQuery({
        queryKey: reviewRequestKeys.quickReviewUsers(params),
        queryFn: () => getQuickReviewUsersApi(params),
        staleTime: 0,
        gcTime: 5 * 60 * 1000,
        refetchOnMount: 'always',
        refetchOnWindowFocus: false,
        ...options,
    });
};

// create quick reviews user ________________________________________________
export const useCreateReviewRequest = (options = {}) => {
    return useMutation({
        mutationFn: createReviewRequestApi,
        ...options,
    });
};
